/**
 * The phone event page (Gabriel 2026-10-21, "the event page mockup is good";
 * docs/mockups/telify-web/phone-event-page.html): below 768px an event's page is the app's own
 * EventDetailScreen, fed the website's reads (shared-client-screens D3, rows E1 to E7). This file
 * is the website's data part.
 *
 * The website's slots: the chat card signs a visitor in with Telegram (a signed-in client's opens
 * the messages, web-account-pages D8; E1), Back returns where the visitor came from on this site,
 * or to the studio's home when they arrived from a link (E2), and Reserve your spot carries the
 * event to the checkout, which signs in and holds the spot, so it never shows Reserving… (E4). A
 * signed-in client holding a spot gets View Booking, which opens their booking page (E3).
 */
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import type { SiteEventDto } from '@telify/shared';

import { DetailLightboxView } from '@/pages/SessionDetailPage/components/DetailLightboxView';
import { getClientTimezone } from '@/pages/SessionDetailPage/detailFormat';
import { EventDetailScreen } from '@/pages/SessionDetailPage/EventDetailScreen';
import { isViewableBooking } from '@/utils/bookingStatus';

import { useSiteStudio } from '../api/site';
import { useSiteBack } from '../pageMover';
import { toEventDetail } from './appShapes';
import { usePhoneChat } from './PhoneDetailFrame';

export function PhoneEventPage({ event }: { event: SiteEventDto | null }) {
  const navigate = useNavigate();
  const onBack = useSiteBack();
  const chat = usePhoneChat('Secure messaging');
  const studio = useSiteStudio().data;
  const tz = useMemo(() => getClientTimezone(), []);
  const booking = event && isViewableBooking(event.userBooking) ? event.userBooking : null;

  return (
    <EventDetailScreen
      status={event ? 'ready' : 'loading'}
      onBack={onBack}
      event={event ? toEventDetail(event) : undefined}
      Lightbox={DetailLightboxView}
      chat={studio?.name ? { businessName: studio.name, line: chat.line, onChat: chat.onChat } : null}
      tz={tz}
      booked={!!booking}
      onViewBooking={() => booking && navigate(`/account/bookings/${encodeURIComponent(booking.id)}`)}
      reserve={{
        onReserve: () => event && navigate(`/checkout?${new URLSearchParams({ event: event.id })}`),
        reserving: false,
        enabled: true,
      }}
    />
  );
}
